import { Environment } from '../../environments/environment';
import { LightShowSegment } from '../lightshow-preview/Segments/lightshow-segment';
import { Engine } from '../_models/Engine';

export function getUrl(value: string = ''): string {
    let baseUrl = Environment.apiUrl;

    if (!baseUrl.endsWith('/')) {
        baseUrl += '/';
    }

    return baseUrl + value;
}

export function formatDateTime(date: Date): string {
    const mm = (date.getMonth() + 1).toString().padStart(2, '0');
    const dd = date.getDate().toString().padStart(2, '0');
    return date ? `${date.getFullYear()}-${mm}-${dd}` : null;
}

export function GetErrorMessage(error): string {
    let errorMessage = error.originalError || error.error || error;

    if(error.error instanceof ProgressEvent) {
      errorMessage = error.message;
    }

    return errorMessage;
}

export function isEmailValid(email): boolean {
    return /(?:[A-z0-9!#$%&amp;&quot;*+/=?^_`{|}~-]+(?:\.[A-z0-9!#$%&amp;&quot;*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[A-z0-9](?:[A-z0-9-]*[A-z0-9])?\.)+[A-z0-9](?:[A-z0-9-]*[A-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[A-z0-9-]*[A-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/.test(email);
  }

export function restrictImageSegmentStartTime(segment: LightShowSegment, engine: Engine): boolean {
    return segment?.position < engine?.imageSegmentStartTimeThreshold * 1000;
}
